import { Select } from 'antd'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

import { rooftopDamageCategories } from './rooftopDamageTypes'

const StyledSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    background-color: #000000 !important;
    border-color: #666666 !important;
    color: white !important;
    min-height: 40px;
  }

  .ant-select-selection-placeholder {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  .ant-select-selection-item {
    color: white !important;
    background-color: #2e7d32 !important;
    border-color: #4caf50 !important;
  }

  .ant-select-selection-item-remove {
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .ant-select-arrow {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  .ant-select-clear {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  &:hover .ant-select-selector {
    border-color: #888888 !important;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: #4caf50 !important;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2) !important;
  }

  /* Dropdown styles */
  .ant-select-dropdown {
    background-color: #1a1a1a !important;
    border: 1px solid #666666 !important;
  }

  .ant-select-item {
    background-color: #1a1a1a !important;
    color: white !important;
  }

  .ant-select-item-option-selected {
    background-color: #2e7d32 !important;
    color: white !important;
  }

  .ant-select-item:hover {
    background-color: #444444 !important;
  }
`

const RooftopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

interface RooftopDamageSelectorProps {
  selectedTypes: string[]
  onSelectionChange: (types: string[]) => void
  annotation: KVAnnotation
}

export const RooftopDamageSelector: FC<RooftopDamageSelectorProps> = ({
  selectedTypes,
  onSelectionChange,
}) => {
  const groupedOptions = rooftopDamageCategories.map((category) => ({
    label: category.label,
    options: category.types.map((type) => ({
      label: type.label,
      value: type.id,
    })),
  }))

  const handleChange = (value: unknown) => {
    const selectedArray = Array.isArray(value) ? (value as string[]) : []
    onSelectionChange(selectedArray)
  }

  return (
    <RooftopContainer>
      <StyledSelect
        mode='multiple'
        placeholder='Select damage types...'
        value={selectedTypes}
        onChange={handleChange}
        options={groupedOptions}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        maxTagCount='responsive'
        allowClear
        dropdownStyle={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #666666',
        }}
        popupClassName='damage-type-dropdown'
      />
    </RooftopContainer>
  )
}
